export default __webpack_public_path__ + "images/BX.8a2afad.png";